/**
 * 关注/粉丝 列表
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export enum FollowType {
    FOLLOW,
    FANS,
}

interface IInput {
    type: FollowType; // 1 关注 2 被关注
    to_umu_id: string;
    size: number;
    page: number;
}

type IParam = Omit<IInput, 'type'>;

export const getFollowings = (param: IParam): Promise<IListResponse<IFollower>> => {
    return fetchData(Api.PROFILE_FOLLOW_LIST, param);
};

export const getFans = (param: IParam): Promise<IListResponse<IFollower>> => {
    return fetchData(Api.PROFILE_FANS_LIST, param);
};

export const getFollowers = (data: IInput): Promise<IListResponse<IFollower>> => {
    const param = {
        to_umu_id: data.to_umu_id,
        size: data.size,
        page: data.page,
    };
    if (data.type === FollowType.FOLLOW) {
        return getFollowings(param);
    }
    return getFans(param);
};
